/* eslint-disable array-bracket-newline */
import Text from '../../../atoms/Text';
import './styles.scss';

interface IGroupProps {
  caption: string;
  periods: string[];
  selected: string;
  onSelect: (tf: string) => void;
}

const Group = ({ caption, periods, selected, onSelect }: IGroupProps) => (
  <div className='timeframe__modal__group'>
    <div className='timeframe__modal__group__caption'>{caption}</div>
    <div className='timeframe__modal__group__items'>
      {periods.map((period: string) => {
        const formattedPeriod = period.replace(/\s/g, '');
        const active = selected === formattedPeriod;
        return (
          <div
            key={period}
            className={`timeframe__modal__group__item ${
              active
                ? 'timeframe__modal__group__item--active'
                : 'timeframe__modal__group__item--normal'
            }`}
            onClick={() => onSelect(formattedPeriod)}
          >
            {active && (
              <div className='timeframe__modal__group__item__check icon-check' />
            )}
            <Text
              size={12}
              className={`text--weight-500 text--${
                active ? 'white' : 'grey-400'
              }`}
            >
              {period}
            </Text>
          </div>
        );
      })}
    </div>
  </div>
);

/**
 * Timeframe select modal
 * @param props
 * @returns
 */
const TimeframeModal = (props: any) => {
  const selected = props.selected;
  const onSelect = props.onSelect;

  const onSelectAndClose = (value: any) => {
    onSelect(value);
    props.onCancel();
  };

  return (
    <div className='timeframe__modal'>
      <div className='timeframe__modal__caption'>Timeframe to change via:</div>
      <Group
        selected={selected}
        onSelect={onSelectAndClose}
        caption='Seconds'
        periods={['1 s', '5 s', '10 s']}
      />
      <Group
        selected={selected}
        onSelect={onSelectAndClose}
        caption='Minutes'
        periods={['1 m', '3 m', '5 m', '15 m', '30 m']}
      />
      <Group
        selected={selected}
        onSelect={onSelectAndClose}
        caption='Hours'
        periods={['1 h', '2 h', '4 h', '6 h', '8 h', '12 h']}
      />
    </div>
  );
};

export default TimeframeModal;
